const SOUND_KEY = "cetf-muted";

export function isMuted() {
  try {
    return localStorage.getItem(SOUND_KEY) !== "0";
  } catch {
    return true;
  }
}

export function setMuted(muted) {
  try {
    localStorage.setItem(SOUND_KEY, muted ? "1" : "0");
  } catch {}
  window.dispatchEvent(new CustomEvent("cetf:sound", { detail: muted }));
}

export function toggleMuted() {
  const next = !isMuted();
  setMuted(next);
  return next;
}
